import React from 'react';

const CollegeBadge = ({ 
  acronym, 
  name, 
  year = "2024" 
}) => {
  return (
    <div 
      className="bg-white rounded-lg p-3 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col items-center text-center"
      role="img"
      aria-label={`${acronym} monogram`}
    >
      {/* Monogram Circle */}
      <div className="w-20 h-20 bg-gray-600 rounded-full flex items-center justify-center mb-2">
        <span className="text-white font-bold text-lg tracking-wide">
          {acronym}
        </span>
      </div>
      
      {/* Year Trend Chip */}
      <div className="text-[11px] px-2 py-0.5 bg-orange-50 text-orange-700 rounded-full">
        {year} trend
      </div>
    </div>
  );
};

export default CollegeBadge;
